// src/pages/Login/AgroPreneurLogin.js
import React from 'react';
import Login from '../../components/Login/Login';

const AgroPreneurLogin = () => {
  return <Login role="agropreneur" />;
};

export default AgroPreneurLogin;
